import React from 'react';
import ReactDOM from 'react-dom';

const senderLabel = (reminder) =>
  reminder?.creatorUsername
  || reminder?.notificationTitle
  || 'Someone';

/**
 * Popup when another user creates a reminder for the current user.
 */
const ReminderInviteModal = ({
  reminder,
  onAccept,
  onReject,
  onLater,
  busy = false,
}) => {
  if (!reminder) return null;

  const sender = reminder.creatorUsername
    ? reminder.creatorUsername
    : String(senderLabel(reminder)).replace(/\s+sent one reminder for you$/i, '') || 'Someone';
  const title = reminder.title || reminder.notificationBody || 'Reminder';
  const description = reminder.description || '';

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[1300] flex items-center justify-center p-4 bg-black/50"
      role="presentation"
    >
      <div
        className="relative w-full max-w-lg rounded-2xl bg-white dark:bg-gray-900 shadow-2xl overflow-hidden outline-none"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="reminder-invite-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="h-2 w-full bg-gradient-to-r from-amber-400 via-orange-300 to-sky-400" />
        <div className="p-6 sm:p-7">
          <p className="text-xs font-bold uppercase tracking-wider text-amber-700 dark:text-amber-300 mb-2">
            Reminder for you
          </p>
          <h3
            id="reminder-invite-title"
            className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white leading-tight"
          >
            {sender} sent one reminder for you
          </h3>
          <p className="mt-3 text-base font-semibold text-gray-800 dark:text-gray-100 break-words">
            {title}
          </p>
          {description ? (
            <p className="mt-2 text-sm text-gray-600 dark:text-gray-300 whitespace-pre-wrap break-words">
              {description}
            </p>
          ) : null}

          <div className="mt-6 flex flex-wrap items-center gap-2">
            <button
              type="button"
              disabled={busy}
              onClick={() => onAccept && onAccept(reminder)}
              className="px-4 py-2 rounded-xl text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50"
            >
              {busy ? '…' : 'Approve'}
            </button>
            <button
              type="button"
              disabled={busy}
              onClick={() => onReject && onReject(reminder)}
              className="px-4 py-2 rounded-xl text-sm font-semibold text-white bg-rose-600 hover:bg-rose-700 disabled:opacity-50"
            >
              Reject
            </button>
            <button
              type="button"
              disabled={busy}
              onClick={() => onLater && onLater(reminder)}
              className="px-4 py-2 rounded-xl text-sm font-semibold text-gray-700 dark:text-gray-200 bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 disabled:opacity-50"
            >
              Will check later
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ReminderInviteModal;
